
import { CalendarType } from '@xeetr/types/enums'
import { CalendarEvent, CalendarResource } from '@xeetr/types/models'
import { format } from 'date-fns'

import ApiService from './common/API.service'

class CalendarService extends ApiService {
  getCalendarEvents = async (
    from: Date,
    to: Date,
    mode: CalendarType
  ): Promise<CalendarEvent[]> => {
    const { data } = await this.get<CalendarEvent[]>(this.buildTenantUrl('calendar/events'), {
      params: {
        from: format(from, 'yyyy-MM-dd'),
        until: format(to, 'yyyy-MM-dd'),
        status: 'active',
        mode,
      },
    })
    return data.map((event) => ({
      ...event,
      start: new Date(event.start),
      end: event.end ? new Date(event.end) : undefined,
      data: event.data,
    }))
  }

  getCalendarResources = async (): Promise<CalendarResource[]> => {
    const { data } = await this.get<CalendarResource[]>(this.buildCommonUrl('calendar/resources'))
    return data
  }
}

export default CalendarService
